export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-5 py-10">
        <h1 className="font-heading text-2xl font-semibold mb-2">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: August 11, 2026</p>

        <div className="space-y-8 text-sm leading-relaxed text-foreground/80">
          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">1. Acceptance of Terms</h2>
            <p>By using Signature Coffee Note ("the Service"), you agree to these Terms of Service. If you do not agree, please stop using the Service.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">2. Accounts</h2>
            <p>You are responsible for the accuracy of your registration details and for keeping your login credentials secure. You are responsible for all activity that occurs under your account.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">3. User Content</h2>
            <p>You retain ownership of the reviews, ratings, photos, and other content you post ("User Content"). You represent that you have the rights necessary to post it and that it does not infringe the rights of others.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">4. License to Use Posted Images</h2>
            <p className="mb-2">By posting photos to the Service, you grant Signature Coffee Note a worldwide, non-exclusive, royalty-free, transferable and sublicensable license to use, reproduce, modify (including cropping, resizing, and color adjustment), publish, distribute, and display those photos for the following purposes:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Displaying them within the Service, including on coffee, cafe, and ranking pages</li>
              <li>Promotion of the Service, including social media posts, advertisements, press materials, and newsletters</li>
              <li>Featured content such as "Today's Pick Up", share images, and thumbnails</li>
              <li>Improving the Service, including analysis and quality checks</li>
            </ul>
            <p className="mt-2">Where practical, photos will be credited with your display name. This license continues for content that has already been published or shared externally, even after you delete the photo or your account, to the extent that removal is not technically feasible. Photos will not be sold to third parties as standalone stock imagery, and we will not use them in a way that materially misrepresents your review.</p>
            <p className="mt-2">If you would like a specific photo removed from promotional use, please contact us through the Service and we will address it within a reasonable period.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">5. Prohibited Conduct</h2>
            <p className="mb-2">You may not:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Post false, misleading, or defamatory reviews</li>
              <li>Post content that infringes copyright, portrait rights, or other rights</li>
              <li>Post unlawful, offensive, or spam content</li>
              <li>Interfere with the operation of the Service or attempt unauthorized access</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">6. Removal of Content</h2>
            <p>We may remove or hide any content that violates these Terms, or suspend accounts, without prior notice.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">7. Disclaimer</h2>
            <p>Reviews and cafe information are user-generated and provided as-is. We do not guarantee accuracy, completeness, or availability, and are not liable for damages arising from use of the Service.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">8. Changes to These Terms</h2>
            <p>We may update these Terms from time to time. If significant changes are made, we will notify you through the Service.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">9. Contact</h2>
            <p>If you have any questions about these Terms, please reach out through the contact feature within the Service.</p>
          </section>
        </div>
      </div>
    </div>
  );
}